var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 77,
    viewBox: "0 0 80 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 77H8C5.87827 77 3.84344 76.175 2.34315 74.7066C0.842854 73.2382 0 71.2466 0 69.1699V26.2963C0.0664941 25.0021 0.455117 23.7435 1.13205 22.6299C1.80897 21.5163 2.7537 20.5815 3.884 19.9069L35.884 1.11469C37.1269 0.38528 38.5488 0 39.998 0C41.4472 0 42.8691 0.38528 44.112 1.11469L76.112 19.9069C78.516 21.3281 79.992 23.8728 80 26.6212V69.1699C80 71.2466 79.1571 73.2382 77.6569 74.7066C76.1566 76.175 74.1217 77 72 77ZM8 29.5027V69.1699H72V29.5027L40 50.3816L8 29.5027ZM40 7.82899L13.264 23.5283L40 40.9738L66.732 23.5283L40 7.82899V7.82899Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b38c20877c77537853bd95e7c3f85f81.svg";
export { ForwardRef as ReactComponent };